import { useQuery } from '@apollo/client'
import gql from 'graphql-tag'

import {
  StoreRequestProvidableItemSearchQuery,
  StoreRequestProvidableItemSearchQueryVariables,
} from '@/clients/utoniq-core/schema'
import { config } from '@/config'
import { useCurrentUser, useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { router } = useRouter<{ artistId: string; keyword: string }>()
  const { user } = useCurrentUser()
  const artistId = router.query.artistId ?? config.artistId

  const { data } = useQuery<
    StoreRequestProvidableItemSearchQuery,
    StoreRequestProvidableItemSearchQueryVariables
  >(QUERY)

  return {
    state: {
      artistId,
      isLoggedIn: !!user,
      userLoggedInId: user?.uid ?? '',
      keyword: router.query.keyword,
      point: data?.prepaidPointBalance?.formattedPrepaidPointBarance ?? '',
    },
    actions: {},
  }
})

const QUERY = gql`
  query StoreRequestProvidableItemSearch {
    prepaidPointBalance {
      prepaidPointId
      balance
      formattedPrepaidPointBarance @client
    }
  }
`
